import object from 'helpers/object'


export const initialState = {
  statisticAll: {},
  statisticSuccess: {},
  statisticPositions: [],
  statisticPositionsPayed: {},
  statisticPositionsPayedTotal: [],
  statisticSuccessByDate: [],
  isFetching: false,
}


export const setStatisticAll = (state, payload) => (
  object.setIn(state, [ 'statisticAll' ], payload)
)

export const setStatisticSuccess = (state, payload) => (
  object.setIn(state, [ 'statisticSuccess' ], payload)
)

export const setStatisticSuccessByDate = (state, payload) => (
  object.setIn(state, [ 'statisticSuccessByDate' ], payload)
)

export const setStatisticPositions = (state, payload) => (
  object.setIn(state, [ 'statisticPositions' ], payload)
)

export const setStatisticPositionsPayed = (state, payload) => (
  object.setIn(state, [ 'statisticPositionsPayed' ], payload)
)

export const setStatisticPositionsPayedTotal = (state, payload) => (
  object.setIn(state, [ 'statisticPositionsPayedTotal' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
